import { useMemo } from 'react';
import styled from 'styled-components';
import { type TextCarouselWebPageBlockDataFragment } from '../../../../../api/fragments/TextCarouselWebPageBlockData';
import { useThemeComponents } from '../../../../../themes';
import breakpoints from '../../../../../utilities/breakpoints';
import renderMarkdown from '../../../../../utilities/renderMarkdown';
import useTranslatedString from '../../../../../utilities/useTranslatedString';
import { StyledTextCarouselBlockMainContainer, StyledColumnBlockContainer, StyledColumnTitle } from '../shared';

const TextCard = styled.div`
    padding: 10px 40px;
    height: 150px;
    background: #f2f2f2;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    div > p:nth-child(1) {
        margin-bottom: 0;
        overflow: hidden;
        text-overflow: ellipsis;

        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
    }

    @media (max-width: ${breakpoints.xxs}) {
        padding: 3px 5px;
    }

    @media (max-width: ${breakpoints.xs}) {
        padding: 3px 5px;
    }

    @media (max-width: ${breakpoints.sm}) {
        padding: 5px;
    }
`;

type TextCarouseBlockProps = {
    textCarouseBlock: TextCarouselWebPageBlockDataFragment;
};
const breaks = ['base', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'];
const TextCarouseBlock = ({ textCarouseBlock }: TextCarouseBlockProps) => {
    const translated = useTranslatedString();
    const { Carousel } = useThemeComponents();

    const { textDescriptions } = textCarouseBlock;

    const slidesPerPage = useMemo(
        () => ({
            base: 1,
            xs: 1,
            s: 1,
            m: 2,
            l: 2,
            xl: 2,
        }),
        []
    );

    if (!textDescriptions?.length) {
        return null;
    }

    return (
        <StyledTextCarouselBlockMainContainer>
            <StyledColumnBlockContainer>
                <Carousel
                    disablePagination={JSON.stringify(breaks.reduce((acc, i) => ({ ...acc, [i]: false }), {}))}
                    slidesPerPage={JSON.stringify(slidesPerPage)}
                >
                    <StyledColumnTitle itemProp="alternativeHeadline" slot="heading">
                        {translated(textCarouseBlock.title)}
                    </StyledColumnTitle>
                    {textDescriptions.map(i => (
                        <TextCard>{renderMarkdown(translated(i))}</TextCard>
                    ))}
                </Carousel>
            </StyledColumnBlockContainer>
        </StyledTextCarouselBlockMainContainer>
    );
};

export default TextCarouseBlock;
